import { PromotionsRepository } from '@lib/api/repository/promotions/promotions.repository';
import {
  PromotionInput,
  PromotionOfferFilters,
  PromotionOfferType,
} from '@lib/types';

import { Requester } from '../clients';
import {
  PromotionDTO,
  PromotionOfferDTO,
  PromotionOfferPageDTO,
  createPromotion,
  createPromotionOffer,
} from './models';

const PATH = '/marketplace/promotions';

export default class PromotionsAPI implements PromotionsRepository {
  async listPublic(slug: string, signal?: AbortSignal) {
    return (
      await Requester.get<PromotionDTO[]>(
        `${PATH}/store/${encodeURIComponent(slug)}`,
        { signal },
      )
    ).data.map(createPromotion);
  }

  async list(signal?: AbortSignal) {
    const { data } = await Requester.get<PromotionDTO[]>(PATH, { signal });

    return data.map(createPromotion);
  }

  async listOffers(
    type: PromotionOfferType,
    gameCode: string | undefined,
    search: string | undefined,
    page: number,
    signal?: AbortSignal,
    filters?: PromotionOfferFilters,
  ) {
    const { data } = await Requester.get<PromotionOfferPageDTO>(
      `${PATH}/offers`,
      {
        signal,
        params: { type, gameCode, search, page, ...filters },
      },
    );

    return { items: data.items.map(createPromotionOffer), total: data.total };
  }

  async preview(input: PromotionInput) {
    const { data } = await Requester.post<PromotionOfferDTO[]>(
      `${PATH}/preview`,
      { body: input },
    );

    return data.map(createPromotionOffer);
  }

  async create(input: PromotionInput) {
    const { data } = await Requester.post<PromotionDTO>(PATH, { body: input });

    return createPromotion(data);
  }

  async update(id: string, input: PromotionInput) {
    const { data } = await Requester.patch<PromotionDTO>(
      `${PATH}/${encodeURIComponent(id)}`,
      { body: input },
    );

    return createPromotion(data);
  }

  async end(id: string) {
    const { data } = await Requester.post<PromotionDTO>(
      `${PATH}/${encodeURIComponent(id)}/end`,
    );

    return createPromotion(data);
  }
}
